<template>
	<div>
		<div v-if="simple" class="simpleLanguageSwitcher">
			<a v-if="locale !== 'de'" :href="urlDe">{{ $t('languageSwitcher.simple.german') }}</a>
			<a v-if="locale !== 'en'" :href="urlEn">{{ $t('languageSwitcher.simple.english') }}</a>
		</div>
		<template v-else>
			<a v-if="locale !== 'de'" :href="urlDe">{{ $t('languageSwitcher.german') }}</a>
			<a v-if="locale !== 'en'" :href="urlEn">{{ $t('languageSwitcher.english') }}</a>
		</template>
	</div>
</template>

<script>
	import {DOMAINS} from "@/common/constants";
  import {mapGetters} from "vuex";

	export default {
		name: "LanguageSwitcher",
		props: {
			simple: {
				type: Boolean,
				default: false
			},
			shared: {
				type: Boolean,
				default: false
			},
		},
		computed: {
      ...mapGetters(['neutral']),
			locale() {
				return this.$i18n.locale;
			},
			urlDe() {
				return DOMAINS[this.neutral].de + '#' + this.$route.fullPath;
			},
			urlEn() {
				return DOMAINS[this.neutral].en + '#' + this.$route.fullPath;
			}
		}
	}
</script>

<style lang="scss" scoped>
	a {
		display: block;
		cursor: pointer;
	}
	.simpleLanguageSwitcher {
		padding: 0 4rem;

		a {
			font-size: 1rem;
		}
	}
</style>